import { render, staticRenderFns } from "./AddCourseSEO.vue?vue&type=template&id=0e40c650&scoped=true"
import script from "./AddCourseSEO.vue?vue&type=script&lang=js"
export * from "./AddCourseSEO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e40c650",
  null
  
)

export default component.exports